module.exports = __webpack_public_path__ + "static/media/2.10.3d20f572.png";